<template>
  <!-- CARD -->
    <div class="card" v-if="viewType === 'brilliant'">
    <header class="card-header compact">
      <div class="card-header-title compact">
        <span class="is-light" style="margin-right:1rem;">
          #{{ version.id }} Version: {{ versionText }}
        </span>
        <div class="tags compact">
        <span v-if="version.state === 'Success'" class="tag is-success">
          {{ version.state }}
        </span>
        <span v-else-if="version.state === 'Building'" class="tag is-warning">
          {{ version.state }}
        </span>
        <span v-else-if="version.state === 'Initiated'" class="tag is-info">
          {{ version.state }}
        </span>
        <span v-else-if="version.state === 'Failed'" class="tag is-danger">
          {{ version.state }}
        </span>
        <span v-else class="tag is-dark">
          {{ version.state }}
        </span>

        <span v-if="version.type == 'Stable'" class="tag is-success">
           {{ version.type }}
        </span>
        <span v-if="version.type == 'Night'" class="tag is-dark">
           {{ version.type }}
        </span>
        <!-- <span v-else class="tag is-light">
           {{ version.type }}
        </span> -->

        <span v-if="version.name" class="tag is-light">
          {{version.name}}
        </span>
        <span class="tag is-light"> 
          Changes count: {{ version.changesCount }}
        </span>
</div>
      </div>

      <div class="card-header-title compact mouse-detrav-hover" style="justify-content: space-between;">
        <div>
        </div>
        <div class="tags compact" >
          <a v-if="(action1 != null && action1.length > 0) && this.userRole != 'readonly'" v-on:click="runAction1" class="tag is-dark">
            {{ action1.charAt(0).toUpperCase() + action1.substr(1) }} </a>
          <a v-if="(action2 != null && action2.length > 0) && this.userRole != 'readonly'" v-on:click="runAction2" class="tag is-dark">
            {{ action2.charAt(0).toUpperCase() + action2.substr(1) }} </a>
        </div>
      </div>
    </header>
  </div>
  <div class="card" v-else-if="viewType === 'deluxe'">
    <header class="card-header compact">
      <p class="card-header-title compact">
         #{{ version.id }} Version: {{ versionText }}
      </p>
    </header>
    <nav class="card-content compact">
      <div class="level compact" style="margin:0; background-color:white">
        <p class="level-item has-text-centered">
          State: {{ version.state }}
        </p>
        <p class="level-item has-text-centered">
          Type: {{ version.type }}
        </p>
        <p class="level-item has-text-centered">
          Changes count: {{ version.changesCount }}
        </p>
      </div>
    </nav>
    <footer class="card-footer">
      <a v-if="(action1 != null && action1.length > 0) && this.userRole != 'readonly'" v-on:click="runAction1" class="card-footer-item compact has-black">{{ action1.charAt(0).toUpperCase() + action1.substr(1) }}</a>
      <a v-if="(action2 != null && action2.length > 0) && this.userRole != 'readonly'" v-on:click="runAction2" class="card-footer-item compact has-black">{{ action2.charAt(0).toUpperCase() + action2.substr(1) }}</a>
    </footer>
  </div>
  <div class="card" v-else>
    <header class="card-header">
      <p class="card-header-title">
        #{{ version.id }} Version: {{ versionText }}
      </p>
    </header>
    <div class="card-content">
      <nav class="level">
        <p class="level-item has-text-centered">
          State: {{ version.state }}
        </p>
        <p class="level-item has-text-centered">
          Type: {{ version.type }}
        </p>
        <p class="level-item has-text-centered">
          Changes count: {{ version.changesCount }}
        </p>
        <!-- <p class="level-item has-text-centered">
        <label class="checkbox">
          <input type="checkbox" v-model="version.isActive"> Active
        </label>
        </p> -->
      </nav>
    </div>
    <footer class="card-footer">
      <a v-if="(action1 != null && action1.length > 0) && this.userRole != 'readonly'" v-on:click="runAction1" class="card-footer-item">{{ action1.charAt(0).toUpperCase() + action1.substr(1) }}</a>
      <a v-if="(action2 != null && action2.length > 0) && this.userRole != 'readonly'" v-on:click="runAction2" class="card-footer-item">{{ action2.charAt(0).toUpperCase() + action2.substr(1) }}</a>
    </footer>
  </div>
  <!-- END CARD -->
</template>

<script>

  import { getVersionText } from "./Utils";

export default {
  name: "version-card",
  props: {
    version: Object,
    action1: String, //Edit
    action2: String //Delete
    },
    computed: {
      versionText: function () {
        return getVersionText(this.version);
      }
    },
  methods: {
    runAction1() {
      this.$emit(this.action1, this.version.id);
    },
    runAction2() {
      this.$emit(this.action2, this.version.id);
    }
  },
  created() {
    console.log("vers -" + this.version);
  }
};
</script>

<style>
.compact.card-header {
  background-color: whitesmoke;
}

.compact.card-header-title {
  padding-top: 1px;
  padding-bottom: 1px;
}

.compact.card-content {
  padding: 0.75rem 1.5rem;
}

.compact.card-footer-item {
  padding-top: 0;
  padding-bottom: 0;
}

.is-info.card-footer-item {
  background-color: hsl(204, 86%, 53%);
  color: white;
}

.is-danger.card-footer-item {
  background-color: hsl(348, 100%, 61%);
  color: white;
}

.has-black.card-footer-item {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/VersionCard.Vue